export default {
  host: process.env.NODE_ENV === 'development' ? 'http://org-test.scfp.com' : '',
  baseUrl: process.env.NODE_ENV === 'development' ? 'http://org.scfp.com/api/fin' : '/api/fin'
  // http://org.scfp.com/ff-lidan/api/fin
}